









































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class ReportVisitaSign extends Vue {
  @Prop() docInfo!: any;

  close() {
    this.clearEnterpriseSignature();
    bus.$emit("closeDocSignDialog");
  }
  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }
  save() {
    var signatureAziendaEmpty: boolean = true;
    //@ts-ignore
    const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
    if (signatureAzienda.isEmpty === false) {
      const payload = {
        idReport: this.docInfo.idReport,
        firmaTutorAziendale: signatureAzienda.data
      };
      
      user
        .dispatchSignReportVisita(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Report visita confermato con successo"
          );
          bus.$emit("loadReports");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }
  refuse() {
    var payload = {
      idReport: this.docInfo.idReport
    };
    if (confirm("Si è certi che non sia stata effettuata nessuna visita?")) {
      user
        .dispatchRefuseReportVisita(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Report visita rifiutato correttamente"
          );
          bus.$emit("loadReports");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }
}
